import React from 'react';

import classes from './Spineer.css';

const spinner = () => {
    return (
        <div className={classes.loader}>Loading...</div>
    )
}


export default spinner;


// WEBPACK FOOTER //
// ./src/components/UI/Spinner/Spinner.js